export const isSpaceOnlyOrEmptyString = str => /(^\s*$|^(%20)+$)/.test(str);
